import throttle from 'lodash.throttle';
import { useEffect, useRef, useState } from 'react';
var useVisibility = function (partial, initialDefault) {
    if (partial === void 0) { partial = true; }
    if (initialDefault === void 0) { initialDefault = false; }
    var _a = useState(initialDefault), isVisible = _a[0], setIsVisible = _a[1];
    var checkedElement = useRef(null);
    var checkVisibility = function (toBeCheckedElement, isPartialVisible) {
        if (!toBeCheckedElement) {
            return false;
        }
        var _a = toBeCheckedElement.getBoundingClientRect(), top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        var topCheck = isPartialVisible ? top + height : top;
        var bottomCheck = isPartialVisible ? bottom - height : bottom;
        var rightCheck = isPartialVisible ? right - width : right;
        var leftCheck = isPartialVisible ? left + width : left;
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return (width !== 0 &&
            height !== 0 &&
            topCheck >= 0 &&
            leftCheck >= 0 &&
            bottomCheck <= windowHeight &&
            rightCheck <= windowWidth);
    };
    useEffect(function () {
        var currentElement = checkedElement && checkedElement.current ? checkedElement.current : null;
        var handleScrollOrResize = throttle(function () { return setIsVisible(checkVisibility(currentElement, partial)); }, 0);
        window.addEventListener('scroll', handleScrollOrResize);
        window.addEventListener('resize', handleScrollOrResize);
        setIsVisible(checkVisibility(currentElement, partial));
        return function () {
            window.removeEventListener('scroll', handleScrollOrResize);
            window.removeEventListener('resize', handleScrollOrResize);
        };
    }, [checkedElement, partial]);
    return [checkedElement, isVisible];
};
export default useVisibility;
//# sourceMappingURL=index.js.map